import createStore from '../legacy/store/createStore';

const initialState = {};
const store = createStore(initialState);

export default store;



// WEBPACK FOOTER //
// ./src/state/appStore.js